/**************************************

THIS IS A PUBLIC CLIENT SIDE CONFIG!

**************************************/
const ENV = process.env.REACT_APP_STAGE;
const projectId = 'prerender';

const chargeBee = {
  site: 'prerender-test',
  domain: null,
};

let tawkToIds = '6656f45f981b6c5647761295/1hv1ql57j';

const serverUrl = {
  webServer: '',
  cmsServer: '',
  authServer: '',
  dataServer: '',
  restServer: 'http://localhost:3030',
  // Only used as a browser redirect target (GSC OAuth relay) — the dashboard
  // never calls visibility's API directly; rest-api proxies that. An
  // environment without a visibility deployment must set '' so the relay is
  // disabled instead of leaking the OAuth code cross-environment.
  visibilityServer: 'https://visibility.dev.prerender.io',
};

let logoUrl = '/assets/img/v2/LogoWithTextVector.svg'; //local env

let userSnapSpaceApiKey;
if (ENV === 'production') {
  userSnapSpaceApiKey = `addc885a-9ba6-4b75-9921-812e354b240e`;
} else {
  userSnapSpaceApiKey = `1b6b862e-de32-445a-bbaa-a8a4b4f565b0`;
}

if (ENV === 'ephemeral') {
  const ephemeralApiUrl = process.env.REACT_APP_DASHBOARD_API_URL;
  serverUrl.webServer = ephemeralApiUrl;
  serverUrl.cmsServer = ephemeralApiUrl;
  serverUrl.authServer = ephemeralApiUrl;
  serverUrl.dataServer = ephemeralApiUrl;
  serverUrl.restServer = 'https://rest-api.prerender-staging.dev';
  serverUrl.visibilityServer = 'https://visibility.dev.prerender.io';

  tawkToIds = '6630da811ec1082f04e940d9/1hsnfb7a2';
  logoUrl = '/assets/img/v2/LogoWithTextVector.svg';
} else if (ENV === 'production') {
  serverUrl.webServer = 'https://dashboard-api.prerender.io';
  serverUrl.cmsServer = 'https://dashboard-api.prerender.io';
  serverUrl.authServer = 'https://dashboard-api.prerender.io';
  serverUrl.dataServer = 'https://dashboard-api.prerender.io';
  serverUrl.restServer = 'https://api.prerender.io';
  serverUrl.visibilityServer = 'https://visibility.prerender.io';

  tawkToIds = '6630da811ec1082f04e940d9/1hsndb2sm';
  logoUrl = '/assets/img/v2/LogoWithTextVector.svg';

  chargeBee.site = 'prerender';
  chargeBee.domain = 'https://billing.prerender.io';
} else if (ENV === 'staging') {
  serverUrl.webServer = 'https://dashboard-api.prerender-staging.dev';
  serverUrl.cmsServer = 'https://dashboard-api.prerender-staging.dev';
  serverUrl.authServer = 'https://dashboard-api.prerender-staging.dev';
  serverUrl.dataServer = 'https://dashboard-api.prerender-staging.dev';
  serverUrl.restServer = 'https://rest-api.prerender-staging.dev';
  serverUrl.visibilityServer = 'https://visibility.dev.prerender.io';

  tawkToIds = '6630da811ec1082f04e940d9/1hsnfb7a2';
  logoUrl = '/assets/img/v2/LogoWithTextVector.svg';
}

let hubspotPortalId = 'local';
if (ENV === 'production') {
  hubspotPortalId = '25756777';
} else if (ENV === 'staging') {
  hubspotPortalId = '145845345';
}

const regexValidText = new RegExp(/^[^~]*$/, 'g'); // only don't allow ~
const gaOptions = ENV === 'production' ? { debug: false } : { debug: false, cookieDomain: 'none' };

// setup Cookie Options for client-side set cookies via universal-cookie:
const cookieOptions =
  ENV === 'production'
    ? {
        path: '/',
        // domain: `.${mainDomain}`,
        // expires: new Date(2291656749000),
        secure: true,
      }
    : {
        path: '/',
        // domain: `.${mainDomain}`
      };

const CF_PROPAGATION_BAR_MINUTES_IN_PRODUCTION = 15;
const CF_PROPAGATION_BAR_MINUTES_ELSEWHERE = 3;

const cfPropagationBarMinutesFor = (stage) =>
  stage === 'production' ? CF_PROPAGATION_BAR_MINUTES_IN_PRODUCTION : CF_PROPAGATION_BAR_MINUTES_ELSEWHERE;

// hold application secrets and config:
module.exports = {
  apiUrl: {
    webServer: serverUrl.webServer,
    dataServer: serverUrl.dataServer,
    authServer: serverUrl.authServer,
    cmsServer: serverUrl.cmsServer,
    restServer: serverUrl.restServer,
    visibilityServer: serverUrl.visibilityServer,
  },

  cookieOptions,
  sessionName: `${projectId}Session`,

  // Google Analytics:
  ga: {
    trackingId: '', // 'UA-179554564-1',
    options: gaOptions,
  },

  regexValid: {
    firstname: /^([0-9a-zA-ZÀ-ž äÄöÖüÜßèé#&+.-]*)$/,
    lastname: /^([0-9a-zA-ZÀ-ž äÄöÖüÜßèé#&+.-]*)$/,
    organization: /^([a-zA-Z0-9À-ž äÄöÖüÜßèé,;:'\-()#%&$@!/?.\\r\n]*)$/,
    email: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
    username: /^([a-zA-Z0-9_@\- \x7f-\xff#.]*)$/,
    // eslint-disable-next-line no-useless-escape
    urlPath: /^([a-zA-Z0-9\-]*)$/,
    // eslint-disable-next-line no-useless-escape
    password: /^([a-zA-Z0-9äÄöÖüÜßèé@?!#\$%&\*+\/=_.,-]*)$/,
    headline: regexValidText,
    posting: regexValidText,
    text: regexValidText,
    twitter: /^@?(\w){1,15}$/,
    // eslint-disable-next-line
    url: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z‌​]{2,63}\b([-a-zA-Z0-9‌​@:%_\+.~#?&=]*)/,
    gtLtEqNum: /^[><=]?(>=)?(<=)?(\d+)?(\.[0-9]+)?$/,
  },

  defaultProfilePicture: '/assets/img/team/anonymous.jpg',
  // defaultOgBackgroundImage: `https://${mainDomain}/assets/img/backgrounds/ogbackground.jpg`,
  SpinningWheelUrl: '/assets/img/SpinningWheel.gif',
  warningIconUrl: '/assets/img/warning.png',
  successIconUrl: '/assets/img/checkmark.png',
  logoUrl,

  pastDate: new Date(1291656749000),
  futureDate: new Date(2291656749000),

  cacheRefreshRatePerMin: 1,

  userSnapSpaceApiKey,
  tawkToIds,
  chargeBee,
  hubspotPortalId,

  cfPropagationBarMinutes: cfPropagationBarMinutesFor(ENV),
};
